import React, {Component} from 'react'
import './mensagens_chat.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faPaperclip, faArrowCircleRight} from '@fortawesome/free-solid-svg-icons'
import ListaMensagens from './lista_mensagens';
import io from 'socket.io-client'


export default class MensagensChat extends Component{
    constructor(){
        super()
        this.sendMessage = this.sendMessage.bind(this)

        this.state= {
            username: '',
            message:'',
            messages:[]
        }

        this.socket = io('localhost:8080')
        this.socket.on('RECEIVE_MESSAGE', function(data){
            addMessage(data);
        })

        const addMessage = data => {
            console.log(data);
            this.setState({messages: [...this.state.messages, data]});
            window.scroll_div()
        };
    }
    
    sendMessage(event){
        event.preventDefault()
        this.socket.emit('SEND_MESSAGE',{
            author: this.state.username,
            message:this.state.message
        })
        this.setState({message:''})
    }

    componentDidMount(){
        window.scroll_div()
    }

    render(){
        return(
            <div className='col-12 col-md-9 mensagens-container'>
                <div className='lista-mensagens' id='mensagem-container'>
                {this.state.messages.map(function(mensagem){
                    if(this.state.username==mensagem.author){
                        return(
                            <div className='mensagem-box mensagem-box-enviada'>
                            <p className='mensagem mensagem-enviada'>{mensagem.message}<span className='data-mensagem
                            '>11:00</span></p>
                            </div>
                        )
                    }else{
                        return(
                            <div className='mensagem-box mensagem-box-recebida'>
                            <p className='mensagem mensagem-recebida'>{mensagem.message}<span className='data-mensagem
                            '>11:00</span></p>
                            </div>
                        )  
                    }
                }.bind(this))}
                    
            </div>
                
                <form>
                    <div className='box-input'>
                        <input type='text' className='input-mensagem' value={this.state.message} onChange={ev => this.setState({message: ev.target.value})}/>
                        <br/>
                        <input type="text" placeholder="Username" value={this.state.username} onChange={ev => this.setState({username: ev.target.value})}/>
                        
                        <FontAwesomeIcon icon={faPaperclip} color='white' size='lg' style={{marginLeft:'2%'}}/>
                        <button onClick={this.sendMessage} style={{border:'none', backgroundColor:'#F87C4C', cursor:'pointer'}}>
                            <FontAwesomeIcon icon={faArrowCircleRight} color='white' size='lg' style={{marginLeft:'10%'}}/>
                        </button>
                    </div>
                </form>
            </div>
        )
    }
}